import { get } from 'lodash'

class GoogleAnalytics {
  constructor (searchFlightData, itemData, eventName, clientId, sessionId, currency) {
    this.searchFlightData = searchFlightData
    this.itemData = itemData
    this.eventName = eventName
    this.clientId = clientId
    this.sessionId = sessionId
    this.currency = currency
    this.commonData = {
      'event': eventName,
      'carrier': clientId,
      'session_id': sessionId
    }
    this.data = null
  }

  pushEvent () {
    let data = { ...this.commonData, ...this.data }
    window.dataLayer.push(data)
    return data
  }

  getItemView (
    isListView,
    value,
    itemCategory,
    itemCategory2,
    itemCategory3,
    itemCategory4,
    itemCategory5,
    price,
    quantityAdt,
    quantityChd,
    quantityInf,
    id,
    name,
  ) {
    const item = {
      item_id: id,
      item_name: name,
      item_category: itemCategory || '',
      item_category2: itemCategory2 || '',
      item_category3: itemCategory3 || '',
      item_category4: itemCategory4 || '',
      item_category5: itemCategory5 || '',
      price: this.formatValue(price || 0),
      quantity_ADT: quantityAdt,
      quantity_CHD: quantityChd,
      quantity_INF: quantityInf
    }

    if (isListView) return item

    value = value ? this.formatValue(value) : value
    item.price_difference = parseFloat(value) !== parseFloat(item.price)
    item.type_of_flight = this.isReturnFlight ? 'return' : 'outbound'

    return {
      currency: this.currency,
      value,
      item_list_id: this.createItemListId(),
      items: [item],
      ...this.searchFlightData
    }
  }

  createItemListId () {
    const { origin, destination, start_date, end_date } = this.searchFlightData
    const startDate = start_date.split('/').join('-')
    let itemListId = `${origin}/${destination}_${startDate}`
 
    if (end_date) {
      const endDate = this.searchFlightData.end_date.split('/').join('-')
      itemListId = `${itemListId}_${destination}/${origin}_${endDate}`
    }

    return itemListId
  }

  getItemsByVariant () {
    const { goingFlight, returnFlight } = this.flights
    const isRoundTrip = !!returnFlight

    const variantDic = {
      ADT: goingFlight.quantity_ADT,
      CHD: goingFlight.quantity_CHD,
      INF: goingFlight.quantity_INF
    }

    let items = this.createItems(goingFlight, variantDic, isRoundTrip)

    if (returnFlight) {
      const returnItems = this.createItems(returnFlight, variantDic, isRoundTrip, true)
      items = [...items, ...returnItems]
    }

    return items
  }

  createItems (flight, variantDic, isRoundTrip, isReturnFlight = false) {
    const items = []

    for (const variant in variantDic) {
      const quantity = variantDic[variant]

      if (quantity) {
        const fare = flight.fares[variant]
        const tax = flight.taxes[variant]
        const fee = flight.fees[variant] ? flight.fees[variant] : 0

        for (let i = 0; i < quantity; i++) {
          const item = {
            item_id: flight.item_id,
            item_list_id: flight.item_list_id,
            item_name: flight.item_name,
            item_category: flight.item_category,
            item_category2: flight.item_category2,
            item_category3: flight.item_category3,
            item_category4: flight.item_category4,
            item_category5: flight.item_category5,
            item_variant: variant,
            price: ((isRoundTrip && isReturnFlight) || !isRoundTrip) ? this.formatValue(fare + tax + fee) : null,
            price_difference: flight.price_difference,
            type_of_flight: flight.type_of_flight
          }

          if (this.eventName === 'add_payment_info') {
            item.price = ((isRoundTrip && isReturnFlight) || !isRoundTrip) ? fare : null
            item.tax = ((isRoundTrip && isReturnFlight) || !isRoundTrip) ? this.formatValue(tax + fee) : null
            item.booking_code = this.bookingCode
            item.payment_type = this.paymentType
          }

          if (this.eventName === 'purchase') {
            item.booking_code = this.bookingCode
            item.status = this.status
            item.tax = ((isRoundTrip && isReturnFlight) || !isRoundTrip) ? this.formatValue(tax + fee) : null
            item.payment_type = flight.payment_type
          }

          items.push(item)
        }
      }
    }

    return items
  }

  formatValue (value) {
    return parseFloat(Number(value).toFixed(2))
  }

  getRbd (fare) {
    return get(fare, 'reservation_booking_designator')
  }

  formatTime (departureTime) {
    return departureTime.substring(0, 5).concat('hs')
  }

  getValue (fare) {
    let value = 0

    if (fare) {
      value = fare.total_equivalent_paid + ((fare.taxes && fare.taxes.total_taxes) || 0) + ((fare.fees && fare.fees.total_fees) || 0)
    }
    return value
  }
}

export {
  GoogleAnalytics
}
